/* ====================================================== */
/*                      default type                      */
/* ====================================================== */
export let WalletStatus;
(function (WalletStatus) {
  WalletStatus["Disconnected"] = "Disconnected";
  WalletStatus["Connecting"] = "Connecting";
  WalletStatus["Connected"] = "Connected";
  WalletStatus["NotExist"] = "NotExist";
  WalletStatus["Rejected"] = "Rejected";
  WalletStatus["Error"] = "Error";
})(WalletStatus || (WalletStatus = {}));
export let Themes;
(function (Themes) {
  Themes["Light"] = "light";
  Themes["Dark"] = "dark";
})(Themes || (Themes = {}));
/* ====================================================== */
/*                  Simple Connect Modal                  */
/* ====================================================== */
export let LogoStatus;
(function (LogoStatus) {
  LogoStatus["Loading"] = "loading";
  LogoStatus["Warning"] = "warning";
  LogoStatus["Error"] = "error";
})(LogoStatus || (LogoStatus = {}));
export let WalletMode;
(function (WalletMode) {
  WalletMode["Extension"] = "extension";
  WalletMode["WalletConnect"] = "wallet-connect";
})(WalletMode || (WalletMode = {}));
export let ButtonShape;
(function (ButtonShape) {
  ButtonShape["Square"] = "Square";
  ButtonShape["Rectangle"] = "Rectangle";
})(ButtonShape || (ButtonShape = {}));
export let QRCodeStatus;
(function (QRCodeStatus) {
  QRCodeStatus["Pending"] = "Pending";
  QRCodeStatus["Done"] = "Done";
  QRCodeStatus["Error"] = "Error";
  QRCodeStatus["Expired"] = "Expired";
})(QRCodeStatus || (QRCodeStatus = {}));